module.exports = __webpack_public_path__ + "src/assets/images/hero_certificate.png?3f2c143fde3e0f87f45369295487dc1f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero_certificate.png
// module id = 994
// module chunks = 1